module.exports = __webpack_public_path__ + "static/media/2.e39c6d5a.svg";